import getConfig from 'next/config';
import React, { useState, useEffect } from 'react';
import fetchSocialStream from '~/api/helpers/fetchSocialStream';
import CmsSocialStream from '../CmsSocialStream';

/**
 * @param {Object} props
 * @param {string} props.streamId
 * @param {string | undefined} [props.language]
 * @returns {React.ReactElement} The rendered component
 */
const SocialStreamContainer = ({ streamId, language }) => {
  const { publicRuntimeConfig } = getConfig();
  const lang = language ?? publicRuntimeConfig.defaultLanguage;

  /** @type {[SocialItemProps[], React.Dispatch<React.SetStateAction<SocialItemProps[]>>]} */
  const [streamItems, setStreamItems] = useState();

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    fetchSocialStream(streamId, lang).then((response) =>
      setStreamItems(response),
    );
  }, []);
  /* eslint-enable react-hooks/exhaustive-deps */
  return <CmsSocialStream items={streamItems} />;
};

export default SocialStreamContainer;
